import { render, staticRenderFns } from "./ProductPrivacy.vue?vue&type=template&id=709c69db&scoped=true&"
import script from "./ProductPrivacy.vue?vue&type=script&lang=js&"
export * from "./ProductPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ProductPrivacy.vue?vue&type=style&index=0&id=709c69db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c69db",
  null
  
)

export default component.exports